var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-description"},[(_vm.title)?_c('div',{staticClass:"icon-text description-title"},[_vm._m(0),_c('span',{staticClass:"marker"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),(_vm.description)?_c('span',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('div',{staticClass:"rays"})])
}]

export { render, staticRenderFns }